export default "__VITE_ASSET__B4V2vQi$__"